// TelcoTrack - Application Bootstrap
// Main entry point for the Angular application

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Must run synchronously before bootstrapModule — async import would run too late.
if (environment.production) {
  enableProdMode();
}

// Bootstrap the application
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error('Error starting app:', err));
